import { AirBestPricesSearchPreferences } from "../../amadeus-client/api";
export default function createAmadeusBestPricesHistogramRequest(_a) {
    var itineraries = _a.itineraries, tripDuration = _a.tripDuration, rangeOfDeparture = _a.rangeOfDeparture, durationFlexibility = _a.durationFlexibility, fareFamilies = _a.fareFamilies;
    var itinerariesFormatted = itineraries.map(function (itinerary) {
        var fromAirport = itinerary.fromAirport, toAirport = itinerary.toAirport;
        var obj = {
            originLocationCode: fromAirport === null || fromAirport === void 0 ? void 0 : fromAirport.locIATA,
            destinationLocationCode: toAirport === null || toAirport === void 0 ? void 0 : toAirport.locIATA,
        };
        return obj;
    });
    var tripDetails = {};
    if (typeof rangeOfDeparture === 'number') {
        tripDetails.rangeOfDeparture = rangeOfDeparture;
    }
    if (typeof durationFlexibility === 'number') {
        tripDetails.durationFlexibility = durationFlexibility;
    }
    if (typeof tripDuration === 'number') {
        tripDetails.tripDuration = tripDuration;
    }
    return {
        "commercialFareFamilies": fareFamilies,
        "travelers": [
            {
                "passengerTypeCode": "ADT"
            }
        ],
        itineraries: itinerariesFormatted,
        "searchPreferences": {
            "mode": AirBestPricesSearchPreferences.ModeEnum.BestByMonth,
            "showPricesPerBound": false,
            "showMilesPrice": false,
            "cheapestPriceInMiles": false
        },
        tripDetails: tripDetails,
    };
}
